import React from 'react';
import PropTypes from 'prop-types';
import {Result} from 'antd';

import {isAzureAuth, isDefaultAuth, isAbbvieAuth} from '@/app/AuthUtils';
import LazyDefaultAuthContainer from '@/app/auth/LazyDefaultAuthContainer';
import LazySsoAzureContainer from '@/app/auth/azure/LazySsoAzureContainer';
import LazySsoAbbvieContainer from '@/app/auth/abbvie/LazySsoAbbvieContainer';

function AuthContainer({children}) {
    if (isDefaultAuth) {
        return <LazyDefaultAuthContainer>{children}</LazyDefaultAuthContainer>;
    } else if (isAzureAuth) {
        return <LazySsoAzureContainer>{children}</LazySsoAzureContainer>;
    } else if (isAbbvieAuth) {
        return <LazySsoAbbvieContainer>{children}</LazySsoAbbvieContainer>;
    } else {
        return <Result status="500" title="Error" subTitle="登录模式设置错误" />;
    }
}

AuthContainer.propTypes = {
    children: PropTypes.node,
};

export default AuthContainer;
